import React, { useEffect, useRef, useState } from "react";
import TableTreeModal from "../../../../../components/BuilderComponents/TableTreeModal";
import Button from "../../../../../components/FormComponents/Button";
import BuilderModal from "../../../../../Layouts/Modal/BuilderModal";
import { EditOnScreenFilter } from "../NewDesktopRecordviewRenderer";
import { ReactSortable } from "react-sortablejs";
import MaterialIcon from "../../../../../components/BuilderComponents/MaterialIcon";

const EditRecordviewOnScreenFilters = ({
  filters,
  saveFilters,
  tableId,
  tableType,
  folderId,
  EditFormFieldsComponent = null
}) => {
  const [isFieldModalOpen, setIsFieldModalOpen] = useState(false);
  const openFieldModal = () => setIsFieldModalOpen(true);
  const closeFieldModal = () => setIsFieldModalOpen(false);

  let modalName;

  switch (tableType) {
    case "form":
      modalName = "Add Fields";
      break;
    default:
      modalName = "Add Filters";
      break;
  }

  const addFilter = (data) => {
    // const filterCopy = [ ...filters ];
    // const filterCopy = [...filters, data];
    // saveFilters(filterCopy);
    // closeFieldModal();
    if (!filters.some((filter) => filter.id === data.id)) {
      const filterCopy = [...filters, data];
      saveFilters(filterCopy);
    }
  };

  const deleteFilter = (index) => {
    // const filterCopy = { ...filters };
    const filterCopy = [...filters.slice(0, index), ...filters.slice(index + 1)];
    saveFilters(filterCopy);
  };

  const handleOrderChange = (reorderedList) => {
    saveFilters(reorderedList);
  };

  const handleEditFilter = (data, index) => {
    if (!data) {
      deleteFilter(index);
    } else {
      const filterCopy = [...filters.slice(0, index), data, ...filters.slice(index + 1)];
      saveFilters(filterCopy);
    }
  };

  return (
    <div>
      <Button variant="secondary" className="mb_2" onClick={openFieldModal}>
        Add
      </Button>
      <div className="flex_column gap_2">
        <ReactSortable
          list={filters}
          setList={handleOrderChange}
          className="left_panel_field_container cursor_move"
          animation="200"
          easing="ease-out"
          handle=".drag-filter-handle"
        >
          {filters.map((filter, index) => (
            <div className="d_flex w_100 align_center mt_2" key={filter.display + index}>
              <MaterialIcon name="drag_indicator" className="drag-filter-handle" />
              <SingleFilter
                key={filter.display + index}
                filter={filter}
                onChange={(d) => handleEditFilter(d, index)}
                tableId={tableId}
                tableType={tableType}
                EditFormFieldsComponent={EditFormFieldsComponent}
              />
            </div>
          ))}
        </ReactSortable>
      </div>
      <BuilderModal isOpen={isFieldModalOpen} onClose={closeFieldModal} modalName={modalName}>
        <TableTreeModal callbackFunction={addFilter} tableId={tableId} tableType={tableType} folderId={folderId} />
      </BuilderModal>
    </div>
  );
};

const SingleFilter = ({ filter, onChange, tableId, tableType, EditFormFieldsComponent }) => {
  const [isEditDropdownOpen, setIsEditDropdownOpen] = useState(false);
  const [dropdownHeight, setDropdownHeight] = useState(0);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsEditDropdownOpen(!isEditDropdownOpen);
  };

  useEffect(() => {
    if (isEditDropdownOpen) {
      setDropdownHeight(dropdownRef.current.scrollHeight);
    } else {
      setDropdownHeight(0);
    }
  }, [isEditDropdownOpen, filter.allow_intersection]);

  const actionInfo = (type, data = null) => ({
    action: type,
    updatedData: data,
    currentData: filter
  });

  const deleteFilter = (e) => {
    e.stopPropagation();
    onChange(null, actionInfo("delete", null));
  };

  const handleChangeEditScreenFilter = (newFilter) => {
    onChange(newFilter, actionInfo("update"));
  };

  const handleChangeCustomFormFields = (name, value) => {
    onChange({ ...filter, [name]: value }, actionInfo("update"));
  };

  const title = `${filter.prefix}.${filter.display}`;
  const name = filter.filter_custom_label || filter.field_custom_label || title;

  return (
    <div className="border_full w_100">
      <div className="p_3 d_flex align_center cursor_pointer justify_between" onClick={toggleDropdown} title={title}>
        <span>{name}</span>
        <div className="d_flex align_center">
          <MaterialIcon name="delete" className="delete_icon" onClick={deleteFilter} aria-label="Delete filter" />
          <MaterialIcon name={isEditDropdownOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"} />
        </div>
      </div>
      <div
        ref={dropdownRef}
        style={{
          height: `${dropdownHeight}px`,
          transition: "height 0.3s ease",
          overflow: "hidden",
          backgroundColor: "white"
        }}
      >
        {EditFormFieldsComponent ? (
          <EditFormFieldsComponent filter={filter} onChange={handleChangeCustomFormFields} />
        ) : (
          <EditOnScreenFilter
            filter={filter}
            onChange={handleChangeEditScreenFilter}
            tableId={tableId}
            tableType={tableType}
          />
        )}
      </div>
    </div>
  );
};

export default EditRecordviewOnScreenFilters;
